import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Player} from '../../../domain/player';

@Component({
  selector: 'sg-player-config',
  templateUrl: './player-config.component.html',
  styleUrls: ['./player-config.component.scss']
})
export class PlayerConfigComponent {
  get inEdit(): boolean {
    return this.editPlayer !== null;
  }

  @Input() players: Player[];
  // @Input() dialogKeuze: boolean;
  @Output() playersChange = new EventEmitter<Player[]>();

  editingPlayer: Player = null;
  editPlayer: Player = null;
  indx: number = null;
  showPcDialog = false;

  addPlayer() {
    this.editingPlayer = null;
    this.editPlayer = {name: null, age: null, gender: null, anxChoice: null, anxChoiceAfter: null, avatarIcon: 0, wisdomCards: 0};
  }

  updatePlayer(player: Player) {
    this.editingPlayer = player;
    this.editPlayer = JSON.parse(JSON.stringify(player));
  }

  playerEdited() {
    if (this.editingPlayer != null) {
      this.players[this.players.indexOf(this.editingPlayer)] = this.editPlayer;
    } else {
      this.players.push(this.editPlayer);
      // console.log(this.editPlayer);
    }
    this.toList();
  }

  toList() {
    this.editingPlayer = null;
    this.editPlayer = null;
  }

  playerToDelete() {
    if (this.editingPlayer != null) {
      this.indx = this.players.indexOf(this.editingPlayer);
      this.players.splice(this.indx, 1);
    }
    this.toList();
  }

  dialogKeuzeFunc($event) {
    if ($event != null) {
        this.playersChange.emit(this.players);
        this.showPcDialog = false;
    } else {
      this.showPcDialog = false;
    }
  }
}
